module.exports = __webpack_public_path__ + "img/15-28-173.5bcab304.jpg";